import { translateBackend } from '@assets/i18n/config';
import type { TranslatedString } from '@interfaces/shared';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { CircularProgress } from '@ovComponents/2-component/circularProgress/circularProgress';
import { useTranslation } from 'react-i18next';

export const ArchivingAsynchronousMessage = ({
  presentObjectTypes,
}: {
  presentObjectTypes?: string;
}) => {
  const { t } = useTranslation(['workflowCompletions']);

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      py={8}
      gap={2}
    >
      <CircularProgress />
      <Typography variant='bodyMedium'>
        {t('workflowCompletions:archiveObjects.archivingMessage', {
          objects: presentObjectTypes,
        })}
      </Typography>
    </Box>
  );
};

export const ArchivingSynchronousMessage = ({
  title,
  subtitle,
}: {
  readonly title: TranslatedString;
  readonly subtitle?: TranslatedString;
}) => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      py={8}
      gap={2}
    >
      <CircularProgress />
      <Typography variant='headingMedium'>{translateBackend(title)}</Typography>
      {subtitle && (
        <Typography variant='bodyMedium'>
          {translateBackend(subtitle)}
        </Typography>
      )}
    </Box>
  );
};
